import { motion } from 'framer-motion';
import { HORECA } from '@/constants/testIds';
import LutfiyeLogo from './LutfiyeSignature';
import { ArrowRight } from 'lucide-react';

const PRODUCTS = [
  {
    src: 'https://www.lutfiye.com/idea/rs/52/myassets/products/010/2.jpg?revision=1775473219',
    name: 'Böğürtlen Marmelat',
    subline: '%80 Böğürtlen · Amasra',
    tag: '01',
    color: '#5D2A47',
    top: '4%',
    left: '10%',
    w: 'w-[260px] lg:w-[300px] xl:w-[340px]',
    z: 20,
    rot: -4,
    delay: 0.15,
  },
  {
    src: 'https://www.lutfiye.com/idea/rs/52/myassets/products/016/9.jpg?revision=1778745072',
    name: 'Organik Sızma Tahin',
    subline: '%100 Susam · Soğuk sızma',
    tag: '02',
    color: '#B08834',
    top: '30%',
    left: '45%',
    w: 'w-[240px] lg:w-[280px] xl:w-[320px]',
    z: 30,
    rot: 5,
    delay: 0.05,
  },
  {
    src: 'https://www.lutfiye.com/idea/rs/52/myassets/products/015/1.jpg?revision=1778745124',
    name: 'Vişne Reçeli',
    subline: '%60 Vişne · Katkısız',
    tag: '03',
    color: '#B03A2E',
    top: '58%',
    left: '4%',
    w: 'w-[210px] lg:w-[240px] xl:w-[270px]',
    z: 10,
    rot: -7,
    delay: 0.25,
  },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.09, delayChildren: 0.15 } },
};
const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export default function Hero() {
  return (
    <section
      id="top"
      data-testid={HORECA.hero}
      className="relative min-h-screen pt-20 md:pt-24 pb-16 paper-cream text-[#1F1F1F] overflow-hidden"
    >
      <div className="grain" />

      {/* Sol üstte döndürülmüş küçük yazı */}
      <div className="hidden lg:block absolute top-40 left-4 z-0 rotate-[-90deg] origin-left" aria-hidden>
        <span className="eyebrow text-[#5A5145]/60 whitespace-nowrap">
          Amasra · Karadeniz · Türkiye
        </span>
      </div>

      {/* Sağ üstte küçük menşe rozeti */}
      <div className="hidden md:flex absolute top-28 right-10 items-center gap-2 z-30">
        <span className="w-8 h-px bg-[#B08834]" />
        <span className="eyebrow text-[#B08834]">Amasra · Karadeniz</span>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-8 items-center relative z-10 min-h-[calc(100vh-96px)]">
        {/* SOL: metin */}
        <motion.div
          variants={container}
          initial="hidden"
          animate="show"
          className="lg:col-span-6 lg:pr-4 relative"
        >
          <motion.div variants={fadeUp} className="flex items-center gap-4 mb-8">
            <span className="w-12 h-px bg-[#B03A2E]" />
            <span className="eyebrow text-[#B03A2E]">Horeca Kanalı · B2B</span>
          </motion.div>

          <motion.div variants={fadeUp} className="mb-6">
            <LutfiyeLogo
              width="w-[260px] md:w-[400px] lg:w-[500px]"
              height="h-[90px] md:h-[140px] lg:h-[170px]"
              color="text-[#1F1F1F]"
            />
          </motion.div>

          <motion.h1
            variants={fadeUp}
            className="font-display text-[36px] md:text-[52px] lg:text-[72px] leading-[1] tracking-[-0.02em] text-[#1F1F1F] font-light max-w-[680px]"
          >
            Otelinizin,
            <br />
            restoranınızın,
            <br />
            cafenizin
            <span className="italic text-[#B03A2E]"> sofrasında</span>.
          </motion.h1>

          <motion.p
            variants={fadeUp}
            className="mt-8 md:mt-10 text-base md:text-lg text-[#5A5145] leading-relaxed max-w-lg font-body font-light"
          >
            Amasra ve Ulus ormanlarından, katkısız ve sertifikalı organik
            reçel, marmelat, pekmez, helva ve tahin. Toptan hacimlerde,
            özel etiket seçenekleriyle.
          </motion.p>

          <motion.div variants={fadeUp} className="mt-8 flex flex-wrap gap-2">
            {['Vegan', 'Glutensiz', 'İlave Şeker İçermez', 'Sertifikalı Organik'].map((t) => (
              <span key={t} className="label-pill text-[#5A5145]">
                {t}
              </span>
            ))}
          </motion.div>

          <motion.div variants={fadeUp} className="mt-10 flex flex-wrap items-center gap-4">
            <a
              href="#iletisim"
              data-testid={HORECA.heroCtaPrimary}
              className="group inline-flex items-center gap-3 bg-[#1F1F1F] hover:bg-[#B03A2E] text-[#FBF7EE] px-8 py-4 tracking-[0.18em] text-xs font-medium transition-colors font-body"
            >
              KURUMSAL TEKLİF
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="#urunler"
              data-testid={HORECA.heroCtaSecondary}
              className="inline-flex items-center gap-3 text-[#1F1F1F] hover:text-[#B03A2E] py-4 tracking-[0.18em] text-xs transition-colors font-body underline underline-offset-8 decoration-1"
            >
              ÜRÜN GRUPLARINA BAK
            </a>
          </motion.div>

          <motion.div variants={fadeUp} className="mt-12 pt-8 border-t border-[#1F1F1F]/15 flex flex-wrap gap-8 md:gap-12">
            {[
              { k: '19+', v: 'Ürün çeşidi' },
              { k: '81 il', v: 'Teslimat' },
              { k: '%100', v: 'Katkısız' },
            ].map((s) => (
              <div key={s.v} className="flex flex-col">
                <div className="font-display text-3xl md:text-4xl text-[#B03A2E] leading-none">
                  {s.k}
                </div>
                <div className="eyebrow text-[#5A5145] mt-2">{s.v}</div>
              </div>
            ))}
          </motion.div>
        </motion.div>

        {/* SAĞ: Estetik ürün kart kompozisyonu */}
        <div className="lg:col-span-6 relative h-[560px] md:h-[680px] lg:h-[740px]">
          {/* Dekoratif halkalar */}
          <div
            className="absolute top-[6%] left-[8%] w-[280px] h-[280px] md:w-[380px] md:h-[380px] rounded-full border border-[#B08834]/25"
            aria-hidden
          />
          <div
            className="absolute top-[36%] right-[6%] w-[260px] h-[260px] md:w-[340px] md:h-[340px] rounded-full border border-[#B03A2E]/18"
            aria-hidden
          />

          {/* Sağ üst köşe: küçük dekor */}
          <div className="absolute top-4 left-4 z-40 flex items-center gap-3">
            <span className="w-6 h-px bg-[#B03A2E]" />
            <span className="eyebrow text-[#B03A2E]">Amasra İmzası</span>
          </div>

          {/* Ürünler */}
          {PRODUCTS.map((p, idx) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 40, rotate: p.rot - 6 }}
              animate={{
                opacity: 1,
                y: [0, -10, 0],
                rotate: p.rot,
                transition: {
                  opacity: { duration: 0.9, delay: 0.4 + p.delay, ease: [0.22, 1, 0.36, 1] },
                  rotate: { duration: 1.1, delay: 0.4 + p.delay, ease: [0.22, 1, 0.36, 1] },
                  y: {
                    duration: 6 + idx,
                    delay: 1.4 + p.delay,
                    repeat: Infinity,
                    ease: 'easeInOut',
                  },
                },
              }}
              className={`absolute ${p.w}`}
              style={{ top: p.top, left: p.left, zIndex: p.z }}
            >
              {/* Polaroid card */}
              <div className="relative bg-[#FFFDF7] p-3 pb-14 shadow-[0_25px_50px_-20px_rgba(31,31,31,0.35),0_0_0_1px_rgba(31,31,31,0.06)]">
                <img
                  src={p.src}
                  alt={p.name}
                  className="w-full h-auto block"
                  loading="eager"
                />
                {/* Caption */}
                <div className="absolute bottom-2.5 inset-x-3 flex items-center justify-between">
                  <div>
                    <div className="font-display italic text-[13px] leading-tight text-[#1F1F1F]">
                      {p.name}
                    </div>
                    <div className="text-[9px] tracking-[0.2em] uppercase text-[#5A5145] mt-0.5">
                      {p.subline}
                    </div>
                  </div>
                  <span
                    className="text-[10px] tracking-[0.28em] font-medium"
                    style={{ color: p.color }}
                  >
                    · {p.tag}
                  </span>
                </div>
                {/* Küçük ince altın çizgi accent */}
                <div
                  className="absolute top-3 right-3 w-8 h-px"
                  style={{ background: p.color, opacity: 0.6 }}
                />
              </div>
            </motion.div>
          ))}

          {/* Botanik dekorasyon — sol alt */}
          <svg
            className="absolute bottom-24 left-6 opacity-30 hidden lg:block pointer-events-none"
            width="90"
            height="120"
            viewBox="0 0 90 120"
            fill="none"
            aria-hidden
          >
            <path
              d="M45 10 Q40 40 45 70 Q50 90 45 115"
              stroke="#3A5A3F"
              strokeWidth="1.2"
              fill="none"
              strokeLinecap="round"
            />
            <path
              d="M45 30 Q30 25 20 35 M45 30 Q60 25 70 35"
              stroke="#3A5A3F"
              strokeWidth="1.2"
              fill="none"
              strokeLinecap="round"
            />
            <path
              d="M45 55 Q28 55 15 70 M45 55 Q62 55 75 70"
              stroke="#3A5A3F"
              strokeWidth="1.2"
              fill="none"
              strokeLinecap="round"
            />
            <ellipse cx="20" cy="35" rx="8" ry="3" fill="#3A5A3F" opacity="0.6" transform="rotate(-30 20 35)" />
            <ellipse cx="70" cy="35" rx="8" ry="3" fill="#3A5A3F" opacity="0.6" transform="rotate(30 70 35)" />
            <ellipse cx="15" cy="70" rx="10" ry="3.5" fill="#3A5A3F" opacity="0.5" transform="rotate(-25 15 70)" />
            <ellipse cx="75" cy="70" rx="10" ry="3.5" fill="#3A5A3F" opacity="0.5" transform="rotate(25 75 70)" />
          </svg>

          {/* Küçük altın çember ornament — sağ üst */}
          <div className="absolute top-16 right-16 w-3 h-3 rounded-full bg-[#B08834] opacity-70 hidden lg:block" aria-hidden />
          <div className="absolute top-24 right-24 w-1.5 h-1.5 rounded-full bg-[#B03A2E] opacity-80 hidden lg:block" aria-hidden />
        </div>
      </div>
    </section>
  );
}
